<template>
    <div class="page-automation-list">
        <h3 class="title">{{ $t("automation.automations") }}</h3>
        <div class="table-wrapper">
            <div class="toolbar">
                <div class="left">
                    <a-input-search
                        style="width: 300px"
                        v-model="searchText"
                        :placeholder="$t('message.startFilter')"
                        class="row search-input"
                        @input="onSearch($event.target.value)"
                    />
                    <CommonFilterTool
                        v-model="breakdownFilter"
                        :keep-state-on-query-params="false"
                        :filter-meta="filterMetas"
                        :label-formatter="filterLabelFormatter"
                        @addFilter="addFilter"
                    />
                </div>
                <div class="right">
                    <SupsisButton primary @click="createEmptyTimerAutomation" :disabled="loading">
                        <i class="material-icons">add</i>
                        {{ $t("automation.createTimerAutomation") }}
                    </SupsisButton>
                    <SupsisButton primary @click="showEventAutomationModal">
                        <i class="material-icons">add</i>
                        {{ $t("automation.createEventBasedAutomation") }}
                    </SupsisButton>
                    <SupsisButton primary @click="showWebhookAutomationModal">
                        <i class="material-icons">add</i>
                        {{ $t("automation.createWebhookAutomation") }}
                    </SupsisButton>
                </div>
            </div>

            <SupsisButton danger v-if="checkboxOption.selectedRowKeys.length > 0" @click="deleteMultiAutomations">
                Delete {{ checkboxOption.selectedRowKeys.length }} selected
            </SupsisButton>
            <SupsisTable
                :columns="getCols()"
                :rows="items"
                :top-pagination="!checkboxOption.selectedRowKeys.length"
                empty-data-bordered
                :bottom-pagination="!checkboxOption.selectedRowKeys.length"
                :pagination-cursor="pagination"
                :options="{
                    checkboxOption,
                    rowStyleOption,
                    clipboardOption,
                    fixedHeader: true,
                    id: 'automation-table',
                    borderX: true,
                    borderY: true,
                }"
                @cursor-changed="(cursor) => (pagination = cursor)"
            />
        </div>

        <Modal2
            v-if="eventAutomationModalVisible"
            :title="$t('automation.createAnEventAutomation')"
            show-title
            :show-footer="false"
            class-name="create-event-automation-modal"
            @cancel="eventAutomationModalVisible = false"
        >
            <EventSelector @save="createEmptyEventAutomation" />
        </Modal2>
        <Modal2
            v-if="webhookAutomationFormModalVisible"
            :title="$t('automation.chatWebhookAutomation')"
            show-title
            :show-footer="false"
            class-name="event-modal"
            @cancel="webhookAutomationFormModalVisible = false"
        >
            <WebhookAutomationForm @save="createWebhookAutomation" />
        </Modal2>
        <Modal2
            v-if="tableSelectionModalVisible"
            title="Tablo Seçimi"
            show-title
            :show-footer="false"
            class-name="table-selection-modal"
            @cancel="tableSelectionModalVisible = false"
        >
            <div class="table-selection-form">
                <div class="event-description" v-if="$event">
                    <template v-if="$event.event === 'table.record_created'">
                        Automasyonu hangi tabloya kayıt eklendiğinde çalıştırmak istiyorsunuz? Lütfen seçim yapınız.
                    </template>
                    <template v-else-if="$event.event === 'table.record_updated'">
                        Automasyonu hangi tablodaki bir kayıt güncellendiğinde çalıştırmak istiyorsunuz? Lütfen seçim
                        yapınız.
                    </template>
                    <template v-else-if="$event.event === 'table.record_deleted'">
                        Automasyonu hangi tablodan bir kayıt silindiğinde çalıştırmak istiyorsunuz? Lütfen seçim
                        yapınız.
                    </template>
                    <template v-else-if="$event.event === 'table.record_automation_button_clicked'">
                        Automasyonu hangi tablodaki bir kayıt üzerindeki otomasyon düğmesine tıklandığında çalıştırmak
                        istiyorsunuz? Lütfen seçim yapınız.
                    </template>
                </div>
                <CustomPicker
                    v-model="selectedTableId"
                    :items="tables"
                    idKey="_id"
                    labelKey="name"
                    title="Tablo Seçin"
                    icon="table_chart"
                />
                <SupsisButton primary @click="createEventAutomationWithTable">Oluştur</SupsisButton>
            </div>
        </Modal2>
    </div>
</template>
<script>
import Vue from "vue";
import CommonFilterTool from "../../../Chatbot/pages/archive/CommonFilterTool.vue";
import SupsisTable from "../../../../../components/SupsisTable.vue";
import NoMessage from "../../../TeamChat/NoMessage.vue";
import log2 from "../../../../../utils/log2";
import HoverMenuCell from "../../../../../components/common/HoverMenuCell.vue";
import moment from "moment/moment";
import { AUTOMATION_API } from "../../../../../api/automation";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import Modal2 from "../../../../../components/common/Modal2.vue";
import EventSelector from "../../components/EventSelector.vue";
import WebhookAutomationForm from "../../components/WebhookAutomationForm.vue";
import { mapState } from "vuex";
import CustomPicker from "../../../../../components/pickers/CustomPicker.vue";

const log = log2("AutomationList");
export default Vue.extend({
    name: "AutomationList",
    components: {
        WebhookAutomationForm,
        EventSelector,
        Modal2,
        SupsisButton,
        NoMessage,
        SupsisTable,
        CommonFilterTool,
        CustomPicker,
    },
    props: ["type"],
    data() {
        return {
            searchText: null,
            items: [],
            pagination: {
                page: 1,
                perPage: 20,
                total: 0,
                defaultPageSize: 50,
                hideOnSinglePage: true,
                pageSizeOptions: [10, 15, 20, 50, 100],
                showQuickJumper: true,
                showSizeChanger: true,
            },
            loading: true,
            loadingInstance: null,
            checkboxOption: {
                selectedRowKeys: [],
                // row select change event
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    console.log("selectedRowChange", { row, isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
                // selected all change event
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    console.log("selectedAllChange", { isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
            },
            rowStyleOption: {
                stripe: true,
            },
            clipboardOption: {
                copy: true,
                paste: false,
                cut: false,
                delete: false,
            },
            filterMetas: [
                {
                    name: "options.trigger",
                    label: "Type",
                    materialIcon: "filter_alt",
                    controlType: "select",
                    defaultValue: null,
                    options: () => [
                        {
                            id: "timer",
                            label: "Timer",
                        },
                        {
                            id: "webhook",
                            label: "Webhook",
                        },
                        {
                            id: "event",
                            label: "Event",
                        },
                        {
                            id: "button",
                            label: "Button",
                        },
                    ],
                },
            ],
            breakdownFilter: [
                {
                    name: "options.trigger",
                    label: "Type",
                    filterValue: null,
                    materialIcon: "filter_alt",
                    controlType: "select",
                    options: () => [
                        {
                            id: "timer",
                            label: "Timer",
                        },
                    ],
                },
            ],
            eventAutomationModalVisible: false,
            webhookAutomationFormModalVisible: false,
            tableSelectionModalVisible: false,
            selectedTableId: null,
        };
    },
    computed: {
        ...mapState({
            tables: (state) => state.table.tables,
        }),
    },
    methods: {
        deleteMultiAutomations() {
            window.confirm("Are you sure to delete selected automations?");

            AUTOMATION_API.deleteMultiAutomations(this.checkboxOption.selectedRowKeys)
                .then(() => {
                    this.$message.success(this.$t("automation.automationsDeletedSuccessfully"));
                    this.checkboxOption.selectedRowKeys = [];
                    this.fetch();
                })
                .catch((error) => {
                    this.$message.error(this.$t("automation.automationsCouldNotBeDeleted"));
                    console.error("Error while deleting automations", error);
                });
        },
        showEventAutomationModal() {
            this.eventAutomationModalVisible = true;
        },
        showWebhookAutomationModal() {
            this.webhookAutomationFormModalVisible = true;
        },
        async createEmptyTimerAutomation() {
            this.loading = true;
            const automation = await AUTOMATION_API.createEmptyTimerAutomation();
            this.$message.success(this.$t("automation.timerAutomationCreatedSuccessfully"));
            this.fetch();
            this.gotoAutomation(automation);
        },
        async createEmptyEventAutomation($event) {
            const { name, event, payload } = $event;
            this.eventAutomationModalVisible = false;

            if (event.startsWith("table")) {
                this.tableSelectionModalVisible = true;
                this.$event = $event; // Seçilen event'i component seviyesinde saklayın
            } else {
                this.loading = true;
                const automation = await AUTOMATION_API.createEmptyEventAutomation(name, event, payload);
                this.$message.success(this.$t("automation.eventAutomationCreatedSuccessfully"));
                this.fetch();
                this.gotoAutomation(automation);
            }
        },
        async createWebhookAutomation($event) {
            const { name, payload } = $event;
            this.webhookAutomationFormModalVisible = false;
            this.loading = true;
            const automation = await AUTOMATION_API.createWebhookAutomation(name, payload);
            this.$message.success(this.$t("automation.webhookAutomationCreatedSuccessfully"));
            this.fetch();
            this.gotoAutomation(automation);
        },
        fetch() {
            const cursor = {
                offset: (this.pagination.page - 1) * this.pagination.perPage,
                limit: this.pagination.perPage,
            };
            const filters = [
                (this.searchText || "").trim().length > 0
                    ? {
                          key: "*",
                          value: (this.searchText || "").trim(),
                      }
                    : undefined,
                this.type
                    ? {
                          key: "options.trigger",
                          value: this.type,
                          operator: "equals",
                      }
                    : undefined,

                ...this.generateFilterParams(),
            ].filter((x) => !!x);
            AUTOMATION_API.listAutomations(filters, cursor)
                .then((response) => {
                    const { items, count } = response;
                    this.items = items;
                    this.pagination.total = count;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.$message.error(this.$t("automation.automationsCouldNotBeFetched"));
                    console.error("Error while fetching automations", error);
                });
        },
        togglePublishState(automation) {
            console.log("togglePublishState", automation);
            AUTOMATION_API.updateAutomationSingleKey(automation._id, "published", !automation.published)
                .then(() => {
                    this.$message.success("Automation published state updated successfully");
                    this.items = this.items.map((item) => {
                        if (item._id === automation._id) {
                            return {
                                ...item,
                                published: !item.published,
                            };
                        }
                        return item;
                    });
                })
                .catch((error) => {
                    this.$message.error(this.$t("automation.automationPublishedStateCouldNotBeUpdated"));
                    console.error("Error while updating automation published state", error);
                });
        },
        getCols() {
            return [
                {
                    field: "",
                    key: "a",
                    type: "checkbox",
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    key: "name",
                    field: "name",
                    title: this.$t("message.name"),
                    width: "",
                    align: "left",
                },
                {
                    key: "options.trigger",
                    field: `options.trigger`,
                    title: this.$t("automation.trigger"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const triggers = {
                            timer: "Zamamlayıcı ile",
                            event:
                                row.options.trigger === "event"
                                    ? `Olay Gerçekleştiğinde (${row.options.event.type})`
                                    : "Olay",
                            button: "Düğme ile",
                            chatbot: "Chatbot ile",
                            webhook: "Webhook ile",
                            "table-button": "Tablo Düğmesi ile",
                        };
                        return <span>{triggers[row.options.trigger]}</span>;
                    },
                },
                {
                    key: "published",
                    field: `published`,
                    title: this.$t("automation.published"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "md-switch",
                            {
                                props: {
                                    class: "md-primary",
                                    id: row._id,
                                    key: row._id,
                                    value: !row.published,
                                },
                                on: {
                                    change: () => this.togglePublishState(row),
                                },
                            },
                            [h("span", row.published ? "On" : "Off")]
                        );
                    },
                },
                {
                    key: "createdAt",
                    field: `createdAt`,
                    title: this.$t("automation.createdAt"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{moment(row.createdAt).format("DD.MM.YYYY HH:mm")}</span>;
                    },
                },
                {
                    title: this.$t("automation.action"),
                    key: "operation",
                    width: "100px",
                    align: "center",
                    operationColumn: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div class="actions">
                                <SupsisButton onClick={() => this.gotoAutomation(row)} ghost primary>
                                    View
                                </SupsisButton>
                            </div>
                        );
                    },
                },
            ];
        },
        generateFilterParams() {
            return this.breakdownFilter
                .map((filter) => {
                    if (!!filter.filterValue) {
                        return {
                            key: filter.name,
                            value: filter.filterValue,
                            operator: "equals",
                        };
                    }
                    return undefined;
                })
                .filter((x) => !!x);
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
            this.fetch();
        },
        addFilter(name, value) {
            log.info("addFilter", name);
            const meta = this.filterMetas.find((x) => x.name === name);
            const filter = this.breakdownFilter.find((x) => x.name === name);
            if (filter) {
                this.breakdownFilter = this.breakdownFilter.map((x) => {
                    if (x.name === name) {
                        x.filterValue = value || meta.defaultValue;
                    }
                    return x;
                });
            } else {
                this.breakdownFilter.push({
                    name: meta.name,
                    label: meta.label,
                    filterValue: value || meta.defaultValue,
                    materialIcon: meta.materialIcon,
                    controlType: meta.controlType,
                    options: meta.options,
                });
            }
        },
        removeFilter(name) {
            log.info("removeFilter", name);
            this.breakdownFilter = this.breakdownFilter.filter((x) => x.name !== name);
        },
        filterLabelFormatter(name, value) {
            const filter = this.filterMetas.find((x) => x.name === name);
            log.info("filterLabelFormatter", { name, value, filter });
            const isSelect = filter.controlType === "select";
            if (isSelect) {
                const option = filter.options().find((x) => x.id === value);
                if (option) {
                    return `${filter.label}: ${option.label}`;
                }
            }
            if (value) {
                return `${filter.label}: ${value}`;
            }
            return filter.label;
        },
        isFilterExists(name) {
            return !!this.breakdownFilter.find((x) => x.name === name);
        },
        gotoAutomation(row) {
            this.$router.push(`/automations/${row._id}/design`);
        },
        async createEventAutomationWithTable() {
            const { name, event, payload } = this.$event;
            this.tableSelectionModalVisible = false;
            this.loading = true;
            const automation = await AUTOMATION_API.createEmptyEventAutomation(name, event, payload, {
                table: this.selectedTableId,
            });
            this.$message.success(this.$t("automation.eventAutomationCreatedSuccessfully"));
            this.fetch();
            this.gotoAutomation(automation);
        },
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector(".table-wrapper"),
            name: "wave",
        });
        if (this.loading) this.loadingInstance.show();
        this.fetch();
    },
    watch: {
        loading(val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
        channelId(val) {
            this.searchText = "";
            this.pagination.page = 1;
            this.fetch();
        },
        pagination: {
            handler(val, oldVal) {
                const pageSizeChanged = val.perPage !== oldVal.perPage;
                if (pageSizeChanged) {
                    this.pagination.page = 1;
                }
                console.log("pagination changed", val);
                this.fetch();
            },
            deep: true,
        },
        breakdownFilter: {
            handler(val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
        type(val) {
            this.fetch();
        },
    },
});
</script>

<style scoped lang="scss">
.page-automation-list {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 10px;

    .table-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .toolbar {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            gap: 5px;

            .left {
                display: flex;
                gap: 5px;
                align-items: center;
            }

            .right {
                display: flex;
                gap: 5px;
            }

            .common-filter-tool {
                border-bottom: none !important;
                padding: unset !important;
            }
        }
    }
}
</style>
<style lang="scss">
.page-automation-list {
    .ant-modal {
        width: 75vw !important;
    }

    .custom-modal-body {
        background: var(--color-bg-default) !important;
    }
}

.create-event-automation-modal {
    .ant-modal {
        width: 70vw !important;
    }
}

.table-selection-form {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .event-description {
        font-size: 16px;
        font-weight: 500;
        color: var(--color-text-strong-default);
    }
}
</style>
